import { Geolocation } from '@capacitor/geolocation';
import { isNativeApp } from './pwa';

/**
 * Get the device's current GPS fix (live location).
 * Uses Capacitor on native Android/iOS; browser Geolocation API on web/PWA.
 */
export async function getCurrentPosition() {
  if (isNativeApp()) {
    const perm = await Geolocation.checkPermissions();
    if (perm.location !== 'granted' && perm.coarseLocation !== 'granted') {
      const req = await Geolocation.requestPermissions();
      if (req.location !== 'granted' && req.coarseLocation !== 'granted') {
        const err = new Error('Location permission denied — enable GPS to send SOS.');
        err.code = 1;
        throw err;
      }
    }
    const pos = await Geolocation.getCurrentPosition({
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 0,
    });
    return {
      coords: {
        latitude: pos.coords.latitude,
        longitude: pos.coords.longitude,
      },
    };
  }

  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported'));
      return;
    }
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 0,
    });
  });
}
